import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles language changes based on URL query parameters
 * This component doesn't render anything, it just handles language changes
 */
export const LanguageHandler: React.FC = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    // Get the language from URL query parameter
    const urlParams = new URLSearchParams(location.search);
    const langParam = urlParams.get('lang');

    // Only change language if it's a supported language and different from current
    if (langParam && ['en', 'pl'].includes(langParam.toLowerCase()) && langParam.toLowerCase() !== i18n.language) {
      i18n.changeLanguage(langParam.toLowerCase());
    }
  }, [location.search, i18n]);

  // This component doesn't render anything
  return null;
};
